import EditLecture from "./EditLecture";

export default EditLecture